import { ApiWrapper, jObjectLittle, jUserLittle } from '../../types';
import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ShareAccessProps, ShareGeneralAccessRules } from '../../types/share';

export class JObjectApi extends JBaseApi {
    public getObject(uri: string): Promise<ApiWrapper<jObjectLittle>> {
        return this.network.post<jObjectLittle>({ o: 'object', f: 'getObject', uri } as OF);
    }

    public setAccess(
        uri: string,
        access: { read: string[]; write: string[] },
        message: string,
        generalAccessRule: ShareGeneralAccessRules,
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'object',
            f: 'setAccess',
            uri,
            access,
            message,
            generalAccessRule,
        } as OF);
    }

    public getAccess(uri: string): Promise<ApiWrapper<ShareAccessProps>> {
        return this.network.post<ShareAccessProps>({
            o: 'object',
            f: 'getAccess',
            uri,
        } as OF);
    }

    public getAccessHash(uri: string): Promise<ApiWrapper<string>> {
        return this.network.post({
            o: 'object',
            f: 'getAccessHash',
            uri,
        } as OF);
    }

    public askAccess(uri: string, askAccess: 'read' | 'write', askMessage?: string): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'object', f: 'askAccess', uri, askAccess, askMessage } as OF);
    }

    public getAccessRequest(uri: string, idUser?: number): Promise<ApiWrapper<jUserLittle[]>> {
        return this.network.post<jUserLittle[]>({
            o: 'object',
            f: 'getAccessRequest',
            format: 'raw-little',
            uri,
            idUser,
        } as OF);
    }

    public setAccessRequest(
        uri: string,
        idUser: number,
        requestAccessValue: 'accept' | 'deny',
        requestResponseMessage?: string,
    ): Promise<ApiWrapper<[]>> {
        return this.network.postCSRF({
            o: 'object',
            f: 'setAccessRequest',
            uri,
            idUser,
            requestAccessValue,
            requestResponseMessage,
        } as OF);
    }
}
